import {showError, showInfo} from '../../ui/ToastNotification';
import {User} from '../user/User';

/**
 * Sends feedback to Zapier hook to show it in Slack
 * @param user - user which sends the feedback
 * @param feedback - feedback message
 * @param page - page where the feedback was sent
 * @param onFinal - callback when feedback is sent
 */
export function sendFeedback(user: User | null, feedback: string, page: string, onFinal: () => void): void {
  fetch('https://hooks.zapier.com/hooks/catch/5688155/bmpvqpz', {
    method: 'POST',
    body: JSON.stringify({
      name: `${user?.firstName} ${user?.lastName}`,
      body: feedback,
      id: user?.id.toString() || '',
      email: user?.email || '',
      page
    })
  }).then(
    () => {
      showInfo('Thank you for your feedback');
    },
    (error) => {
      showError(error.message);
    }
  ).finally(() => {
    onFinal();
  });

}
